import React from "react";
import { ICONS } from "../utils/assets";
import { Link } from "react-router-dom";

const Breadcrumbs = ({ items }) => {
  const isLastItem = (index) => index === items.length - 1;

  return (
    <div className="breadcrumbs">
      {items.map((item, index) => (
        <span
          className={`breadcrumbs__item paragraph-md ${
            isLastItem(index) && items.length > 1 ? "text-neutral-950" : ""
          }`}
          key={index}
        >
          {isLastItem(index) ? (
            item.name
          ) : (
            <Link to={item.path}>{item.name}</Link>
          )}

          {isLastItem(index) ? (
            ""
          ) : (
            <img
              src={ICONS.CARET_ICON}
              alt="Caret icon"
              className="breadcrumbs__icon"
            />
          )}
        </span>
      ))}
    </div>
  );
};

export default Breadcrumbs;
